import styled from 'styled-components';

type StatusVariant = 'pending' | 'accepted' | 'rejected';

const STATUS_COLORS: Record<StatusVariant, { bg: string; color: string }> = {
  pending: { bg: '#fff7ed', color: '#c2710c' },
  accepted: { bg: '#16a34a', color: '#ffffff' },
  rejected: { bg: '#ef4444', color: '#ffffff' }
};

export const SummaryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
`;

export const SummaryChip = styled.div<{ variant: StatusVariant }>`
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 600;
  background: ${({ variant }) => (variant === 'pending' ? '#fff7ed' : variant === 'accepted' ? '#ecfdf3' : '#fef2f2')};
  color: ${({ variant }) => (variant === 'pending' ? '#c2710c' : variant === 'accepted' ? '#15803d' : '#dc2626')};

  i.icon {
    margin: 0;
    font-size: 13px;
  }
`;

export const CellBadge = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  padding: 4px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  background: #ffffff;
  white-space: nowrap;

  i.icon {
    margin: 0;
    font-size: 11px;
  }
`;

export const StatusBadge = styled.span<{ variant: StatusVariant }>`
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background: ${({ variant }) => STATUS_COLORS[variant].bg};
  color: ${({ variant }) => STATUS_COLORS[variant].color};

  i.icon {
    margin: 0;
    font-size: 11px;
  }
`;

export const FieldName = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
`;

export const FieldSub = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
`;

export const ValueText = styled.span<{ strike?: boolean }>`
  font-size: 14px;
  color: ${({ strike }) => (strike ? '#94a3b8' : '#0f172a')};
  text-decoration: ${({ strike }) => (strike ? 'line-through' : 'none')};
  word-break: break-word;
`;

export const Muted = styled.span`
  color: #cbd5e1;
`;

export const Reviewer = styled.span`
  font-size: 13px;
  color: #94a3b8;
`;
